import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'components/DatePicker';
import ValidatedFormInput from 'components/ValidatedFormInput';

function ValidatedDatePicker({ input, meta, minDate }) {
  let selectedDate = null;

  if (input.value) {
    selectedDate =
      input.value instanceof Date ? input.value : new Date(input.value);
  }

  return (
    <DatePicker
      onChange={input.onChange}
      selected={selectedDate}
      minDate={minDate}
      customInput={<ValidatedFormInput meta={meta} input={input} />}
    />
  );
}

ValidatedDatePicker.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  minDate: PropTypes.instanceOf(Date),
};

ValidatedDatePicker.defaultProps = {
  minDate: null,
};

export default ValidatedDatePicker;
